// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  // :: chartOptions
  // :: Its the variable that defines the chart properties in the view called ProductsChart.vue
  chartOptions: {
    chart: {
      type: "solidgauge",
      height: 170,
      style: {
        fontFamily: "Oswald"
      }
    },
    title: null,
    pane: {
      center: ["50%", "75%"],
      size: "150%",
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: "#EEE",
        innerRadius: "60%",
        outerRadius: "100%",
        shape: "arc"
      }
    },
    tooltip: {
      enabled: false
    },
    // the value axis
    yAxis: {
      lineWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 400,
      tickWidth: 0,
      title: {
        y: -70
      },
      labels: {
        y: 16
      },
      min: 0,
      max: 100
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: 5,
          borderWidth: 0,
          useHTML: true
        }
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        data: [
          {
            color: "#FF4141",
            y: 0
          }
        ],
        dataLabels: {
          format: `<div style="text-align:center; margin-top:-45px">
                <span style="font-family: 'Oswald', sans-serif !important; font-size:1.25rem !important; font-weight:400; color:#FF4141">{y}%</span>
                <br/><span style="font-size:14px;color:silver">Equipos</span></div>`
        },
        tooltip: {
          valueSuffix: " km/h"
        }
      }
    ]
  },
  data: {},
  totalProducts: 0,
  productsInService: 0,
  productsInServiceLastPeriod: 0,
  productsInServiceLastYear: 0,
  productsInServicePercentage: 0,
  branchOffice: "toluca",
  productsOnServiceTop: [],
  productsDemanded: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
